export const formatDate = (dateInput: Date | string, format: string) => {
    let date: Date;
    // Convert string to Date if necessary
    if (typeof dateInput === 'string') {
        date = new Date(dateInput);
    } else {
        date = dateInput;
    }
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const shortMonth = date.toLocaleString('default', { month: 'short' });
    const longMonth = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    const formatMap: { [key: string]: string | number } = {
        'MMMM': longMonth,
        'MMM': shortMonth,
        'DD': day.toString().padStart(2, '0'),
        'D': day,
        'MM': month.toString().padStart(2, '0'),
        'M': month,
        'YYYY': year,
        'YY': year % 100
    };
    switch (format) {
        case "EEE":
            return new Intl.DateTimeFormat("en-US", { weekday: "short" }).format(date);
        case "d":
            return new Intl.DateTimeFormat("en-US", { day: "numeric" }).format(date);
        case "MMM":
            return new Intl.DateTimeFormat("en-US", { month: "short" }).format(date);
        default:
            // Order longest to shortest!
            return format.replace(/MMMM|MMM|DD|D|MM|M|YYYY|YY/g, match => `${formatMap[match]}`);
    }
};
export const formatUploadDate = (dateValue: string | undefined): string => {
    if (!dateValue) {
        return new Date("2026-01-01T10:00:00").toISOString();
    }
    // Check if date already contains time (has 'T' or includes time portion)
    if (dateValue.includes('T') || dateValue.includes(':')) {
        return new Date(dateValue).toISOString();
    }
    return new Date(`${dateValue}T10:00:00`).toISOString();
};